
import React from 'react'
import withFormState from 'src/components/aciacehighway/hocs/withFormState';
import { CreateTradePartner } from '../component/trade-partner-form';
import { ScopedCssBaseline } from '@mui/material';

function AddPage({ history }) {
  return (<ScopedCssBaseline>
    <CreateTradePartner history={history} />
  </ScopedCssBaseline>);
}

export default withFormState(AddPage)
